export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '2ab8a8cf-34cb-42ca-afad-bcd5d58e30f0';
export const MODAL_CLOSE_SEC = 2.5;